import moment from "moment";

const formatTimestamp = (timestamp) => {
  const localDateTime = moment(timestamp).local();
  return localDateTime.format("DD-MMM-YYYY hh:mm a");
};

export default formatTimestamp;